import { __extends, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { propTypes, defaultProps } from './ErrorPage.types.js';
import SvgError403 from '../../img/error_403.svg.js';
import SvgError404 from '../../img/error_404.svg.js';
import SvgError500 from '../../img/error_500.svg.js';
import SvgSpotonLogo from '../../img/spoton_logo.svg.js';
import styles from './ErrorPage.module.scss.js';

var ErrorPage = /** @class */ (function (_super) {
    __extends(ErrorPage, _super);
    function ErrorPage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getImg = function (error) {
            switch (error) {
                case '403':
                    return React__default.createElement(SvgError403, null);
                case '500':
                    return React__default.createElement(SvgError500, null);
                case '404':
                default:
                    return React__default.createElement(SvgError404, null);
            }
        };
        _this.getErrorMessage = function (error) {
            switch (error) {
                case '403':
                    return 'You don’t have permission to access this page.';
                case '500':
                    return 'Something went wrong. Please try again.';
                case '404':
                default:
                    return 'We can’t find the page you’re looking for.';
            }
        };
        return _this;
    }
    ErrorPage.prototype.render = function () {
        var _a = this.props, className = _a.className, errorCode = _a.errorCode, title = _a.title, errorMessage = _a.errorMessage, ctaContent = _a.ctaContent, shouldDisplayLogo = _a.shouldDisplayLogo;
        return (React__default.createElement("div", { className: clsx(styles.ErrorPage, className), "data-testid": this.props['data-testid'] },
            shouldDisplayLogo ? (React__default.createElement("div", { className: styles.ErrorPage_spotOnLogo, "data-testid": "ErrorPage-logo" },
                React__default.createElement(SvgSpotonLogo, null))) : null,
            React__default.createElement("div", { className: styles.ErrorPage___wrapperContent },
                React__default.createElement("div", { className: styles.ErrorPage___textContentContainer },
                    React__default.createElement("div", { className: styles.ErrorPage_errorMessageContainer },
                        React__default.createElement("h1", { className: styles.ErrorPage_errorMessageContainer___errorMessageTitle }, title),
                        React__default.createElement("p", { className: styles.ErrorPage_errorMessageContainer___errorMessage }, errorMessage ||
                            this.getErrorMessage(errorCode))),
                    ctaContent && (React__default.createElement("div", { className: styles.ErrorPage___actions }, ctaContent))),
                React__default.createElement("div", { className: styles.ErrorPage___errorImg }, this.getImg(errorCode)))));
    };
    ErrorPage.displayName = 'ErrorPage';
    ErrorPage.propTypes = propTypes;
    ErrorPage.defaultProps = __assign({}, defaultProps);
    return ErrorPage;
}(React__default.Component));

export { ErrorPage, ErrorPage as default };
